"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgAmenityEv = function SvgAmenityEv(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M992 128H860.8c-16-44.8-57.6-80-108.8-80s-92.8 35.2-108.8 80H377.6C364.8 83.2 323.2 48 272 48s-92.8 35.2-108.8 80H32c-19.2 0-32 12.8-32 32v784c0 19.2 12.8 32 32 32h960c19.2 0 32-12.8 32-32V160c0-19.2-12.8-32-32-32zm-32 784H64V432h896v480zm0-544H64V192h896v176zM240 672c0-19.2 12.8-32 32-32h32v-32c0-19.2 12.8-32 32-32s32 12.8 32 32v32h32c16 0 32 12.8 32 32s-12.8 32-32 32h-32v32c0 19.2-12.8 32-32 32s-32-12.8-32-32v-32h-32c-19.2 0-32-12.8-32-32zm368 0c0-19.2 12.8-32 32-32h128c19.2 0 32 12.8 32 32s-12.8 32-32 32H640c-19.2 0-32-12.8-32-32z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgAmenityEv, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;